import axios from 'axios'
import { Filter } from '../../components/_WMS/FilterComponent'
import { ApiConfig } from '../../config/api'
import { utcFinalDate, utcIntialDate } from '../../utils/dateHelper'
import { ExternalAuditResume } from './entities/ExternalAudit'

export const getExternalAuditList = (
  filters?: Filter[],
  page = 0,
  pageSize = 5,
  continuationToken?: string | undefined
) => {
  const url = new URL(`${ApiConfig.ExternalAuditApi}/GetList`)
  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      if (
        element.key === 'initialTransactionDate' ||
        element.key === 'initialCreatedDate'
      ) {
        url.searchParams.set(element.key, utcIntialDate(element.value))
      } else if (
        element.key === 'finalCreatedDate' ||
        element.key === 'finalTransactionDate'
      ) {
        url.searchParams.set(element.key, utcFinalDate(element.value))
      } else if (element.key === 'productOriginId') {
        url.searchParams.set('brand', element.displayValue)
      } else if (element.key === 'externalStatusId') {
        url.searchParams.set('statusId', element.value)
      } else {
        url.searchParams.append(element.key, element.value.toString())
      }
    })
  }

  if (continuationToken)
    url.searchParams.append('continuationToken', continuationToken)

  return axios.get(url.toString())
}

export const getExternalAudit = (externalAuditId: string) => {
  const url = new URL(`${ApiConfig.ExternalAuditApi}/Get/${externalAuditId}`)

  return axios.get(url.toString())
}

export const postSendMessageEntity = (dto: ExternalAuditResume) => {
  const url = new URL(`${ApiConfig.ExternalAuditApi}/PostEntityMessage`)

  return axios.post(url.toString(), dto)
}
